module.exports = __webpack_public_path__ + "img/13@2x.26ccf52a.png";